import { useQuery } from "@tanstack/react-query";

import { MS_PER_MINUTE } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, PetYardWeatherResponse } from "@/types";

// guac caches the forecast for an hour, so polling faster only rereads it.
const WEATHER_REFRESH_MS = 60 * MS_PER_MINUTE;

export const petYardWeatherQueryKey = ["pet-yard-weather"] as const;

// Fetched when the playyard opens; `null` means the weather API was down and
// the yard should fall back to the clock alone.
export function useGetPetYardWeather({ isEnabled }: { isEnabled: boolean }) {
  return useQuery({
    queryKey: petYardWeatherQueryKey,
    queryFn: async () => {
      const path = "pets/yard-weather";
      const res = await guacHttpClient.get<
        PetYardWeatherResponse,
        HttpResponse<PetYardWeatherResponse>
      >(path);
      return res.data;
    },
    enabled: isEnabled,
    staleTime: WEATHER_REFRESH_MS,
    refetchInterval: WEATHER_REFRESH_MS,
  });
}
